import { createSelector } from '@ngrx/store';
import { getHistoryOrderTypeGroup } from '../getHistoryOrderTypeGroup';

export const isHistoryOrderDelivery = (orderGUID: string) => createSelector(getHistoryOrderTypeGroup(orderGUID), (type) => type === OLO.Enums.COLLECTION_TYPE.DELIVERY);
